import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  static targets = ["link"]
  static values = { 
    profile: String,
    url: String,
    text: String,
    moduleType: String,
    moduleId: String
  }

  connect() {
    // Initialiser Ahoy si pas déjà fait
    if (typeof ahoy === 'undefined') {
      this.loadAhoy()
    }
  }

  trackClick(event) {
    event.preventDefault()

    const link = event.currentTarget
    const profileSlug = link.dataset.trackProfile
    const profileId = link.dataset.trackProfileId
    const url = link.dataset.trackUrl
    const text = link.dataset.trackText
    const moduleType = link.dataset.trackModuleType
    const moduleId = link.dataset.trackModuleId

    // Déterminer si le lien est externe
    const isExternal = this.isExternalLink(url)

    // Tracker l'événement
    if (typeof ahoy !== 'undefined') {
      if (document.querySelector('meta[name="rho-owner"]')) return
      ahoy.track('link_click', {
        profile_slug: profileSlug,
        profile_id: profileId,
        link_url: url,
        link_text: text,
        module_type: moduleType,
        module_id: moduleId,
        external: isExternal.toString(),
        referrer: window.location.href
      })
    }

    // Rediriger après un court délai
    setTimeout(() => {
      window.open(url, '_blank')
    }, 100)
  }

  isExternalLink(url) {
    if (!url) return false

    try {
      const linkUrl = new URL(url, window.location.href)
      const currentHost = window.location.hostname

      // Compare hostnames (ignore www prefix)
      const linkHost = linkUrl.hostname.replace(/^www\./, '')
      const currentHostNormalized = currentHost.replace(/^www\./, '')

      return linkHost !== currentHostNormalized
    } catch (e) {
      // Si l'URL est invalide, considérer comme externe par sécurité
      return true
    }
  }

  loadAhoy() {
    // Charger Ahoy dynamiquement si nécessaire
    const script = document.createElement('script')
    script.src = 'https://unpkg.com/ahoy.js@0.4.2/dist/ahoy.min.js'
    script.onload = () => {
      ahoy.configure({
        urlPrefix: '',
        visitsUrl: '/ahoy/visits',
        eventsUrl: '/ahoy/events'
      })
    }
    document.head.appendChild(script)
  }
}